import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import { deleteEventOccasion } from "../actions";

export function CreateEventOccasion() {
  return (
    <Link to={"/admin/event-occasions/create"}>
      <Button className="mt-4">
        Create Event Occasion
        <Icon icon={PlusIcon} label="Create Event Occasion" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateEventOccasion({ id }: { id: string }) {
  return (
    <Link to={`/admin/event-occasions/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteEventOccasion({ id }: { id: string }) {
  const navigate = useNavigate();

  const deleteEventOccasionWithId = deleteEventOccasion.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this event occasion?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteEventOccasionWithId, {
    success: false,
  });
  useEffect(() => {
    if (state.success) {
      navigate("/admin/event-occasions?reload=true", { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}



